import { render, staticRenderFns } from "./embedded-recommendation.vue?vue&type=template&id=55857426&functional=true"
import script from "./embedded-recommendation.vue?vue&type=script&lang=js"
export * from "./embedded-recommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports